var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeradata = function SvgTeradata(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f27241",
    d: "M24 4a20 20 0 1 0 0 40 20 20 0 1 0 0-40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.515 31.366c-1.446.609-3.478 1.137-4.935.192-1.159-.752-1.58-2.116-1.58-2.85V21h5v-5h-5v-5h-5v17.707c0 2.064 1.002 5.124 3.828 6.956 1.08.7 2.623 1.336 4.665 1.336 1.419 0 3.08-.306 4.993-1.113z"
  })));
};
export default SvgTeradata;